import * as React from 'react';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose } from 'redux';
import { Entity, CompetitionEntity, CompetitionEntityScore, Competition } from '../../userApi';
import { State } from '../../redux/state';
import { connect } from 'react-redux';
import * as selectors from '../../redux/selectors';
import { estimateEntityDollarSavings } from '../../utils/actionSavings';

interface ManualProps {
  entity: Entity;
}

interface Props extends ManualProps {
  competitionEntity: CompetitionEntity;
  competitionEntityScore: CompetitionEntityScore;
  rank: number;
  competition: Competition;
  dollarsSaved: number;
  showDollarSavings: boolean;
}

const EntityStats = ({
  competitionEntity, competitionEntityScore, t, formatNumber,
  dollarsSaved, showDollarSavings
}: LProps<Props>) => (
  <div className="cc__white_box">
    <div className="cc__stats__item">
      <div className="cc__stats__label">{t('Points')}</div>
      <div>{formatNumber(competitionEntityScore.points, 0)}</div>
    </div>
    {/*{(rank || '') && <div className="cc__stats__item">
      <div className="cc__stats__label">{t(getRankLabel(entity))}</div>
      <div>{formatNumber(rank, 0)}</div>
</div>} Gets rid of the rank on entity page.*/}
    <div className="cc__stats__item">
      <div className="cc__stats__label">{t('Participants')}</div>
      <div>{formatNumber(competitionEntity.memberCount || 0, 0)}</div>
    </div>
    <div className="cc__stats__item">
      <div className="cc__stats__label">{t('Actions')}</div>
      <div>{formatNumber(competitionEntity.pledgeCount, 0)}</div>
    </div>
    <div className="cc__stats__item">
      <div
        className="cc__stats__label"
        dangerouslySetInnerHTML={{
          __html: t('Pounds CO<sub>2</sub> reduced')
        }}
      />
      <div>{formatNumber(competitionEntityScore.savingsCO2Lbs, 0)}</div>
    </div>
    {showDollarSavings && (
      <div className="cc__stats__item">
        <div className="cc__stats__label" title={t('Water saved (gallons)')}>{t('Water Saved (gal)')}</div>
        <div>{formatNumber(competitionEntityScore.savingsWaterOz || 0, 0)}</div>
      </div>
    )}
    {showDollarSavings && (
      <div className="cc__stats__item">
        <div className="cc__stats__label" title={t('Estimated San Francisco bill savings')}>{t('$ Saved')}</div>
        <div>${formatNumber(Math.round(dollarsSaved), 0)}</div>
      </div>
    )}
  </div>
);

const mapStateToProps = (state: State, ownProps: ManualProps): Partial<Props> => {
  const competitionName = String((state.competition && state.competition.name) || '').toLowerCase();
  const competitionEntityScore = selectors.entityScore(state, ownProps);
  return {
    competitionEntity: state.competitionEntities[ownProps.entity.id],
    competitionEntityScore,
    rank: selectors.entityRank(state, ownProps),
    competition: state.competition,
    showDollarSavings: competitionName === 'ccsf' || competitionName === 'sf' || competitionName === 'sfenvironment',
    dollarsSaved: estimateEntityDollarSavings(competitionEntityScore, state.competitionPledges)
  };
};

export default compose(
  withLocalization('entity'),
  connect(mapStateToProps)
)(EntityStats) as React.SFC<ManualProps>;
